import { isDefined } from "@clipboard-health/util-ts";
import { convertToGeoLocation } from "@src/appV2/Location";
import { useEnableGeofenceTracking } from "@src/appV2/Location/geofence/hooks/useEnableGeofenceTracking";
import { GeofenceProvider } from "@src/appV2/Location/geofence/useGeofence";
import { type ShiftStateData } from "@src/appV2/Shifts/Shift/ShiftState/types";
import { type WorkerShift } from "@src/appV2/Shifts/Shift/types";

import { ParkingCard } from "./ParkingCard";

interface ParkingCardWithGeofenceProps {
  shift: WorkerShift;
  workerId: string;
  shiftState: ShiftStateData;
}

export function ParkingCardWithGeofence(props: ParkingCardWithGeofenceProps) {
  const { shift, workerId, shiftState } = props;

  const facilityGeoLocation = isDefined(shift.facility.geoLocation.coordinates)
    ? convertToGeoLocation(shift.facility.geoLocation.coordinates)
    : undefined;

  const enableGeofenceTracking = useEnableGeofenceTracking({
    shiftStart: shift.start,
    shiftState,
  });

  return (
    <GeofenceProvider
      shiftId={shift._id}
      workerId={workerId}
      workplaceId={shift.facilityId}
      initialLocation={undefined}
      fallbackGeofenceLocation={facilityGeoLocation}
      enableGeofenceTracking={enableGeofenceTracking}
    >
      <ParkingCard shift={shift} workerId={workerId} shiftState={shiftState} />
    </GeofenceProvider>
  );
}
